import { DownloadBlockItem } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.state'
import { BlocksView } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.template'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { pushDatalayer } from '@shared/Frontend/seo/datalayer'
import { cn } from '@shared/Frontend/utils/addToClassName'
import React, { useId } from 'react'
import { BlockActions } from '../shared/blockActions'
import { BlockHeader } from '../shared/blockHeader'
import { SVGIcon } from '@shared/Frontend/utils/svg'

export const DownloadBlock: BlocksView['DownloadBlock'] = (props) => {
  const { id, items } = props
  if (items?.length == 0) return <></>

  const { inView, ref } = useInView({ threshold: 0.1 })
  return (
    <section id={id} ref={ref} className={cn('block block--download ls-spacing', inView && 'inview')}>
      <div className="block__inner ls-container ls-gutter gridsys--columns">
        <BlockHeader {...props} headerClassName='gridsys--50p' />

        <div className="block__content gridsys--50p">
          <ListLayout items={items} listClassName="block__list" />
          <BlockActions {...props} datalayerCategory="download_block" />
        </div>
      </div>
    </section>
  )
}

const ListLayout = (props: { items: DownloadBlockItem[]; listClassName?: string }) => {
  return (
    <ul className={cn('list', props.listClassName)}>
      {props.items.map((item, index) => {
        if (!item.url) return <></>
        return <ItemLayout key={index} {...item} />
      })}
    </ul>
  )
}

const ItemLayout = (props: DownloadBlockItem) => {
  const { url, title, description } = props
  const id = useId()
  return (
    <li className="list__item">
      <a
        id={`download-item-${id}`}
        download={true}
        target="_blank"
        rel="noopener noreferrer"
        href={url}
        className="list__link"
        onClick={() => pushDatalayer({ category: 'download_block', label: title, action: 'download_item_click' })}
      >
        <div className="list__text">
          {title && <p className="list__title title--xs">{title}</p>}
          {description && <p className="list__description text--md">{description}</p>}
          <SVGIcon className='list__icon' id="icon-downloads" size={24} />
        </div>
      </a>
    </li>
  )
}
